import { render, staticRenderFns } from "./HandoverList.vue?vue&type=template&id=212188a9&scoped=true&"
import script from "./HandoverList.vue?vue&type=script&lang=ts&"
export * from "./HandoverList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212188a9",
  null
  
)

export default component.exports